export default __webpack_public_path__ + "static/media/add.dbf99316.svg";